<template>
	<div class="WorkOrderDetail">
		<div class="WorkOrderDetail-container table-box" v-if="workorderData.title">
			<div class="workorder-detail-header">
				<div class="workorder-info">
					<div class="workorder-info-head">
						<div class="level" v-if="workorderData.status == 4 || workorderData.status == 5" :class="renderLevel(workorderData.priority).className">
							{{renderLevel(workorderData.priority).txt}}
						</div>
						<div v-else class="level" @click.stop="levelPanelToggle" :class="renderLevel(workorderData.priority).className">
							{{renderLevel(workorderData.priority).txt}}
							<div class="levelPanel" v-if="showLevelPanel">
								<div class="levelItem" @click.stop="editWorkorderPriority(workorderData.id, 0)">低</div>
								<div class="levelItem" @click.stop="editWorkorderPriority(workorderData.id, 1)">中</div>
								<div class="levelItem" @click.stop="editWorkorderPriority(workorderData.id, 2)">高</div>
								<div class="levelItem" @click.stop="editWorkorderPriority(workorderData.id, 3)">紧急</div>
							</div>
						</div>
						<!-- <div :title="workorderData.title">{{workorderData.title.length > 15 ? workorderData.title.slice(0, 15) +
              '...' : workorderData.title}}
						</div> -->
						<div class="workorder-status" :class="renderProcessState(workorderData.status).className">
							{{renderProcessState(workorderData.status).txt}}
						</div>
						<div class="workorder-function">
							<div class="function-item">
								<div v-if="workorderData.status == 4 || workorderData.status == 5">
									{{workorderData.categoryName ? workorderData.categoryName : '--'}}
								</div>
								<div v-else>
									<el-cascader v-model="setRules" placeholder="未设置" @change="rulesChange" ref="categoryCascader" class="rule-content"
									 :options="optionRules" :props="{ emitPath: false }" :show-all-levels="false"></el-cascader>
								</div>
							</div>
							<div class="function-item">
								<div>分配给：</div>
								<div v-if="workorderData.status == 4 || workorderData.status == 5">
									{{workorderData.authorName}}
								</div>
								<div v-else>
									<el-cascader v-model="defaultOption" :options="options" @change="csChange" ref="myCascader" :show-all-levels="false"></el-cascader>
								</div>
							</div>
							<div class="function-item" v-if="false">
								<div>抄送给：</div>
								<div>123</div>
							</div>
						</div>
					</div>

				</div>
				<div class="workorder-operation">
					<div class="workorder-operation-item" style="padding-top: 2px;" @click="withoutHandle" v-if="workorderData.status != 5 && workorderData.status != 4">
						<button class="tb-btn tb-btn-del">关闭</button>
					</div>
					<div class="workorder-operation-item" @click="solveHandle" v-if="workorderData.status != 4 && workorderData.status != 5">
						<button class="tb-btn tb-btn-edit">已解决</button>
					</div>
					<div class="workorder-operation-item" @click="reloadWorkorder" v-if="workorderData.status == 4 || workorderData.status == 5">
						<button class="tb-btn tb-btn-edit">重新打开</button>
					</div>
				</div>
			</div>
			<div class="workorder-detail-main">
				<div class="workorder-record-container" style="border-bottom: 1px dashed #ccc;">
					<div class="workorder-record-head">
						<div class="workorder-record-head-icon">
							<svgicon name="workorderAdd" class="workorderAdd" width="18" height="18"></svgicon>
						</div>
						<div class="from-user">{{workorderData.authorName}}</div>
						<div class="workorder-record-tips">创建了新工单</div>
						<div class="workorder-record-time">{{workorderData.createTimeStr}}</div>
					</div>
					<div class="workorder-content" v-html="workorderData.content"></div>
					<div v-if="workorderData.visitorId" style="padding: 0px 20px 8px;box-sizing: border-box;color: #3a8ee6;display: inline-block;cursor: pointer;font-weight: bold;"
					 @click="viewChatHistory">
						<svgicon name="msgWorkorder" width="18" style="margin-right: 6px;" height="18"></svgicon>
						<span>对话记录</span>
					</div>
				</div>
				<div class="workorder-record-container" v-for="(item, index) in detailList" :key="index">
					<div class="workorder-record-head" v-if="item.actionType != 1">
						<div class="workorder-record-head-icon">
							<svgicon :name="renderActionIcon(item.actionType)" :class="renderActionIcon(item.actionType)" width="18" height="18"></svgicon>
						</div>
						<div class="from-user">{{item.csName}}</div>
						<div class="workorder-record-tips" v-html="item.content"></div>
						<div class="to-user" v-if="item.assigneeName">{{item.assigneeName}}</div>
						<div class="to-user" v-if="item.categoryName">{{item.categoryName}}</div>
						<div class="workorder-record-time">{{item.createTimeStr}}</div>
					</div>
					<!-- <div class="workorder-record-head" v-else>
						<div class="workorder-record-head-icon">
							<img :src="renderAvatar(item.csHeadimg)" alt="">
						</div>
						<div class="from-user">{{item.csName}}</div>
						<div class="workorder-record-time">{{item.createTimeStr}}</div>
					</div>
					<div v-if="item.actionType == 1" style="padding: 0 26px;box-sizing: border-box;">
						<div class="reply-conent" v-if="item.contentType == 1" v-html="formatTrendEmoji(item.content)"></div>
						<div class="reply-conent" v-if="item.contentType == 2"><img :src="item.content" alt=""></div>
					</div> -->
				</div>
			</div>
			<div class="workorder-detail-main workorder-detail-chatRecordWrap" ref="chatRecordWrap">
				<div class="workorder-record-container" v-for="(item, index) in replyList" :key="index">
					<div class="workorder-record-head" v-if="item.actionType == 1">
						<div class="workorder-record-head-icon">
							<img :src="renderAvatar(item.csHeadimg)" alt="">
						</div>
						<div class="from-user">{{item.csName}}</div>
						<div class="workorder-record-time">{{item.createTimeStr}}</div>
					</div>
					<div v-if="item.actionType == 1" style="padding: 0 26px;box-sizing: border-box;">
						<div class="reply-conent" v-if="item.contentType == 1" v-html="formatTrendEmoji(item.content)"></div>
						<div class="reply-conent" v-if="item.contentType == 2"><img :src="item.content" alt=""></div>
					</div>
				</div>
				<div class="no-data" v-if="replyList.length==0">暂无回复记录</div>
			</div>
			<div class="workorder-detail-footer" v-if="workorderData.status != 4 && workorderData.status != 5">
				<vue-emoji @selectedEmoji="selectEmoji" v-show="showEmoji"></vue-emoji>
				<div class="chat-tool-bar">
					<svgicon name="meh" @click.native="showEmojiFn" width="20" height="20" style="margin-right: 6px;cursor: pointer;"
					 class=""></svgicon>
					<svgicon name="image" width="20" @click.native="chooseImage" height="20" class="" style="cursor: pointer;"></svgicon>
					<input type="file" ref="imageFile" @change="sendImage" v-show="false">
				</div>
				<div class="chat-input-container">
					<textarea v-model="textarea" @keydown="textareaKeyDown($event)" class="chat-input" placeholder="请输入"></textarea>
				</div>
				<div class="send-msg-btn clearfix"><span @click="replyWorkorder">发送</span></div>
			</div>

		</div>
		<div class="WorkOrderDetail-container" v-else>
			<div class="no-data">
				<span class="s-icon s-icon-data"></span>
				<p>从左侧列表打开工单</p>
			</div>
		</div>
		<div class="workorder-from-user-container" v-if="false">
			<div>

			</div>
			<div>
				<div class="no-data">
					<span class="s-icon s-icon-data"></span>
					<p>暂无顾客信息</p>
				</div>
			</div>
		</div>
		<el-dialog title="对话记录" :visible.sync="dialogChatHistoryVisible" class="dialogChatHistory" width="700px"
		 :before-close="handleChatHistoryClose" :modal="false">
			<div class="loadHistory" v-if="historyStatus"><span @click="handlerLoadHistory">查看历史消息</span></div>
			<div class="messages" id="chatContainer" ref="detailCont" v-if="historyList.length > 0">
				<div class="client-event clearfix" v-for="(msg, index) in historyList" v-if="msg.role == 'event'">
					<span>{{ msg.text }}</span>
					<span>&nbsp;</span>
					<span class="msg-date">
						<span>{{ msg.sendtime | formatTime }}</span>
					</span>
				</div>
				<div class="msg-agent clearfix" v-else-if="msg.role == 'agent'">
					<div class="time-sender">
						<span class="time">{{ msg.sendtime | formatTime }}</span>
						<span style="padding-left: 5px;">{{ msg.agent_nickname}}</span>
					</div>
					<div class="j-user">
						<span class="agent-name" v-if="renderAvatar(msg.agent_avatar) ? true : false">
							<img :src="renderAvatar(msg.agent_avatar)" alt="">
						</span>
						<span class="agent-name" v-else>{{ msg.role | formatRole }}</span>
					</div>
					<div class="bubble clearfix">
						<div class="content_container clearfix">
							<div class="text" v-if="msg.msg_type == 'text'" v-html="$utils.renderUrl(formatTrendEmoji(msg.text))"></div>
							<div class="text" v-else-if="msg.msg_type == 'image'">
								<img :src="msg.text" class="upload-img" preview="2">
							</div>
							<div class="text" v-else-if="msg.msg_type == 'file'">
								<i class="el-icon-document"></i>
								<span>{{ msg.text.split(',')[0] }}</span>
								<a :href="msg.text.split(',')[1]" target="_blank">下载文件</a>
							</div>
							<div class="goodsLink" v-else-if="msg.msg_type == 'goods'" @click="goodsLinkerHandler(JSON.parse(msg.text).link)">
								<div class="goodsMain">
									<div class="goodsLef">
										<span><img :src="JSON.parse(msg.text).img" alt=""></span>
									</div>
									<div class="goodsRig">
										<h3>{{ JSON.parse(msg.text).title }}</h3>
										<p><em>￥</em>{{ JSON.parse(msg.text).price }}</p>
									</div>
								</div>
							</div>
							<div class="couponMsg" v-else-if="msg.msg_type == 'coupon'">
								<div class="couponMain">
									<div class="couponLef">
										<img src="../../../assets/images/icon_yhq.png" alt="">
									</div>
									<div class="couponRig">
										<h3>{{ JSON.parse(msg.text).title }}</h3>
										<div class="time">
											<span>{{ disposeDate(JSON.parse(msg.text).start_time) }}</span>
											-
											<span>{{ disposeDate(JSON.parse(msg.text).end_time) }}</span>
										</div>
										<div class="price">{{ JSON.parse(msg.text).price }}</div>
									</div>
								</div>
							</div>
							<div class="expressLink" v-else-if="msg.msg_type == 'express'">
								<div class="expressMain">
									<div class="express-top">
										<span class="order-no">{{ JSON.parse(msg.text).order_no }}</span>
										<span class="fr" v-if="visitorData.sourceQk == 'wfx'">
											<a v-if="JSON.parse(msg.text).status == 0" style="color: #F4403D">待付款</a>
											<a v-if="JSON.parse(msg.text).status == 1" style="color: #F4403D">待发货</a>
											<a v-if="JSON.parse(msg.text).status == 2" style="color: #F4403D">待收货</a>
											<a v-if="JSON.parse(msg.text).status == 3">交易完成</a>
											<a v-if="JSON.parse(msg.text).status == 4" style="color: #F4403D">订单关闭</a>
											<a v-if="JSON.parse(msg.text).status == 5" style="color: #F4403D">卖家同意退/换货</a>
											<a v-if="JSON.parse(msg.text).status == 6" style="color: #F4403D">退/换货中</a>
										</span>
										<span class="fr" v-if="visitorData.sourceQk == 'wxapp_auth'">
											<a v-if="JSON.parse(msg.text).status == 0" style="color: #F4403D">待付款</a>
											<a v-if="JSON.parse(msg.text).status == 1" style="color: #F4403D">已付款</a>
											<a v-if="JSON.parse(msg.text).status == 2" style="color: #F4403D">已接单</a>
											<a v-if="JSON.parse(msg.text).status == 3">已发货</a>
											<a v-if="JSON.parse(msg.text).status == 4" style="color: #F4403D">已提货</a>
											<a v-if="JSON.parse(msg.text).status == 5" style="color: #F4403D">买家已取消</a>
											<a v-if="JSON.parse(msg.text).status == 6" style="color: #F4403D">过期未付款关闭</a>
											<a v-if="JSON.parse(msg.text).status == 7" style="color: #F4403D">已拒单</a>
											<a v-if="JSON.parse(msg.text).status == 8" style="color: #F4403D">退款中</a>
											<a v-if="JSON.parse(msg.text).status == 9" style="color: #F4403D">已退款</a>
											<a v-if="JSON.parse(msg.text).status == 10" style="color: #F4403D">已部分退款</a>
											<a v-if="JSON.parse(msg.text).status == 11" style="color: #F4403D">已完成</a>
										</span>
									</div>
									<div class="expressLef">
										<img :src="JSON.parse(msg.text).img" alt="">
									</div>
									<div class="expressRig">
										<h3>{{ JSON.parse(msg.text).title }}</h3>
										<div class="price"><span>￥</span>{{ JSON.parse(msg.text).price }}</div>
									</div>
								</div>
							</div>
							<div class="voice text clearfix" @click="voicePlay($event)" v-else-if="msg.msg_type == 'voice'">
								<div class="play_voice clearfix" data-time="46">
									<span>{{msg.talk_time}}</span>''
									<audio class="audioId" preload="auto" hidden="true" :index="index" ref="audio">
										<source :src="msg.text" type="audio/mpeg">
									</audio>
									<div class="wifi-symbol voice-agent">
										<div class="wifi-circle first"></div>
										<div class="wifi-circle second" ref="second"></div>
										<div class="wifi-circle third" ref="third"></div>
									</div>
								</div>
							</div>
							<div class="video_css" v-else-if="msg.msg_type == 'video'">
								<video class="videoId" preload controls controlslist="nodownload" @click="videoStop($event)">
									<source :src="msg.text" type="video/mp4" />
								</video>
								<div class="video_mask">
									<svgicon class="video_play_iocn" name="play" @click="videoPlay($event)"></svgicon>
								</div>
							</div>
							<div class="placeOrderMsg" v-if="msg.msg_type === 'place_order'">
								<div v-if="JSON.parse(msg.text).status == 0" class="orderTitle">亲，您有一笔订单未付款~</div>
								<div v-else class="orderTitle">核对订单信息</div>
								<a :href="JSON.parse(msg.text).goodsUrl" target="_blank" class="orderGood-container">
									<div class="goods-image">
										<img :src="JSON.parse(msg.text).image" alt="">
									</div>
									<div class="goods-detail">
										<div class="goods-order-title">{{JSON.parse(msg.text).title}}</div>
										<div class="goods-order-detail">共计{{JSON.parse(msg.text).goodsNum}}件商品，合计￥{{JSON.parse(msg.text).payment}}</div>
									</div>
								</a>
								<div class="addressInfo" v-if="JSON.parse(msg.text).status != 0">
									<span class="label">地址：</span><span class="detail">{{JSON.parse(msg.text).receiverAddress}}</span>
								</div>
							</div>
							<div class="arrivalMsg" v-if="msg.msg_type === 'arrival_notice'">
								<div class="orderTitle">验收提醒</div>
								<a :href="JSON.parse(msg.text).goodsUrl" target="_blank" class="orderGood-container">
									<div class="goods-image">
										<img :src="JSON.parse(msg.text).image" alt="">
									</div>
									<div class="goods-detail">
										<div class="goods-order-title">{{JSON.parse(msg.text).title}}</div>
										<div class="goods-order-detail">共计{{JSON.parse(msg.text).goodsNum}}件商品，合计￥{{JSON.parse(msg.text).payment}}</div>
									</div>
								</a>
								<div class="deliveryTips">
									{{JSON.parse(msg.text).acceptanceMsg}}
								</div>
							</div>
							<div class="deliveryMsg" v-if="msg.msg_type === 'delivery_notice'">
								<div class="orderTitle">订单已发货</div>
								<a :href="JSON.parse(msg.text).goodsUrl" target="_blank" class="orderGood-container">
									<div class="goods-image">
										<img :src="JSON.parse(msg.text).image" alt="">
									</div>
									<div class="goods-detail">
										<div class="goods-order-title">{{JSON.parse(msg.text).title}}</div>
										<div class="goods-order-detail">共计{{JSON.parse(msg.text).goodsNum}}件商品，合计￥{{JSON.parse(msg.text).payment}}</div>
									</div>
								</a>
								<div class="deliveryInfo" v-if="showMore" v-for="(item, i) in JSON.parse(msg.text).logistics" :key="i">
									<div class="deliveryInfo-item">
										<div class="deliveryInfo-label">物流公司：</div>
										<div class="deliveryInfo-detail">{{item.express}}</div>
									</div>
									<div class="deliveryInfo-item">
										<div class="deliveryInfo-label">快递单号：</div>
										<div class="deliveryInfo-detail">{{item.expressNo}}</div>
									</div>
								</div>
								<div class="deliveryInfo" v-if="JSON.parse(msg.text).logistics[0] && !showMore">
									<div class="deliveryInfo-item">
										<div class="deliveryInfo-label">物流公司：</div>
										<div class="deliveryInfo-detail">{{JSON.parse(msg.text).logistics[0].express}}</div>
									</div>
									<div class="deliveryInfo-item">
										<div class="deliveryInfo-label">快递单号：</div>
										<div class="deliveryInfo-detail">{{JSON.parse(msg.text).logistics[0].expressNo}}</div>
									</div>
								</div>
								<div style="text-align: center;cursor:pointer;font-size: 18px;padding-top: 3px;color: #ccc;" v-if="JSON.parse(msg.text).logistics.length > 1 && !showMore">
									<i @click="showMore = true" class="el-icon-arrow-down"></i>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="msg-client clearfix" v-else-if="msg.role == 'client'">
					<div class="time-sender">
						<span class="time">{{ msg.sendtime | formatTime }}</span>
					</div>
					<div class="j-user">
						<span class="agent-name none" v-if="visitorData.visitorHeadimg ? true : false">
							<img :src="renderAvatar(visitorData.visitorHeadimg)" alt="">
						</span>
						<span class="agent-name" v-else>{{ msg.role | formatRole }}</span>
					</div>
					<div class="bubble clearfix">
						<div class="content_container clearfix">
							<div class="text" v-if="msg.msg_type == 'text'" v-html="$utils.renderUrl(formatTrendEmoji(msg.text))"></div>
							<div class="text" v-else-if="msg.msg_type == 'image'">
								<img :src="msg.text" class="upload-img" preview="2">
							</div>
							<div class="text" v-else-if="msg.msg_type == 'file'">
								<i class="el-icon-document"></i>
								<span>{{ msg.text.split(',')[0] }}</span>
								<a :href="msg.text.split(',')[1]" target="_blank">下载文件</a>
							</div>
							<div v-else-if="msg.msg_type == 'goods'">
								<div class="goodsLink" v-if="visitorData.sourceQk == 'wxapp_auth'" @click="goodsWxappHandler">
									<div class="goodsMain">
										<div class="goodsLef">
											<span>
												<img style="margin: 0 auto;" :src="JSON.parse(msg.text).img" alt="">
											</span>
										</div>
										<div class="goodsRig">
											<h3>{{ JSON.parse(msg.text).title }}</h3>
										</div>
									</div>
								</div>
								<div class="goodsLink" v-else @click="goodsLinkerHandler(JSON.parse(msg.text).link)">
									<div class="goodsMain">
										<div class="goodsLef">
											<span><img :src="JSON.parse(msg.text).img" alt=""></span>
										</div>
										<div class="goodsRig">
											<h3>{{ JSON.parse(msg.text).title }}</h3>
											<p><em>￥</em>{{ JSON.parse(msg.text).price }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="voice text clearfix" @click="voicePlay($event)" v-else-if="msg.msg_type == 'voice'">
								<div class="play_voice clearfix" data-time="46">
									<span>{{msg.talk_time}}</span>''
									<audio class="audioId" preload="auto" hidden="true" :index="index" ref="audio">
										<source :src="msg.text" type="audio/mpeg">
									</audio>
									<div class="wifi-symbol voice-client">
										<div class="wifi-circle first"></div>
										<div class="wifi-circle second" ref="second"></div>
										<div class="wifi-circle third" ref="third"></div>
									</div>
								</div>
							</div>
							<div class="video_css" v-else-if="msg.msg_type == 'video'">
								<video class="videoId" preload controls controlslist="nodownload" @click="videoStop($event)">
									<source :src="msg.text" type="video/mp4" />
								</video>
								<div class="video_mask">
									<svgicon class="video_play_iocn" name="play" @click="videoPlay($event)"></svgicon>
								</div>
							</div>
							<div class="goodsLink" v-else-if="msg.msg_type == 'sale'">
								<div class="title">
									<span>当前交易({{ JSON.parse(msg.text).number }})</span>
								</div>
								<div class="goodsMain">
									<div class="goodsLef">
										<span><img :src="JSON.parse(msg.text).goods[0].imgUrls" alt=""></span>
									</div>
									<div class="goodsRig">
										<h3>{{ JSON.parse(msg.text).goods[0].title }}</h3>
										<h4>共{{ JSON.parse(msg.text).goods.length }}件商品，合计￥{{ JSON.parse(msg.text).total_price
                      }}</h4>
									</div>
								</div>
								<div class="goodsButtom">
									<p><span>姓名：</span>{{ JSON.parse(msg.text).consignee_name }}</p>
									<p><span>电话：</span>{{ JSON.parse(msg.text).consignee_phone }}</p>
									<p><span>地址：</span>{{ JSON.parse(msg.text).consignee_address }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else style="text-align: center;padding-top: 30px;">暂无会话记录</div>
		</el-dialog>
	</div>
</template>

<script>
	import VueEmoji from '@/libs/emoji/Emoji'
	import emojiData from '@/libs/emoji/emoji-data'

	export default {
		name: "workOrderDetail",
		props:['ticketId'],
		data() {
			return {
				showLevelPanel: false,
				dialogChatHistoryVisible: false,
				pageNum: 1,
				historyList: [],
				historyStatus: true,
				visitorData: null,

				showEmoji: false,
				sendBtn: false,
				textarea: '',
				options: [],
				defaultOption: [],

				workorderData: {},
				detailList: [], //actionType: 1为回复，2为转派，3为已解决，4为不需处理，5为重新打开，6为抄送，7为修改优先级
				replyList:[],
				replyParams: {
					ticketId: this.ticketId,
					content: '',
					contentType: '' // 类型 text或者image
				},
				optionRules: [],
				setRules: '',
				isSendMsg: false,
				hasOperate:false
			}
		},
		components: {
			VueEmoji
		},
		created() {
			this.getSortData()
		},
		mounted() {
			// this.ticketId = this.$route.query.id
			// this.replyParams.ticketId = this.$route.query.id
			this.textarea = ''
			this.pageNum = 1
			this.historyList = []
			this.historyStatus = true
			this.visitorData = null
			this.getAllService()
			this.$nextTick(() => {
			    this.getWorkorderDetail(this.ticketId)
			})
			let _this = this
			document.addEventListener('click', function() {
				_this.showLevelPanel = false
			}, false)
		},
		watch:{
			ticketId:function(val,old_val){
				if(val!=old_val){
					this.textarea = ''
					this.pageNum = 1
					this.historyList = []
					this.historyStatus = true
					this.visitorData = null
					this.replyParams.ticketId = this.ticketId
					this.getAllService()
					this.$nextTick(() => {
					    this.getWorkorderDetail(this.ticketId)
					})
					let _this = this
					document.addEventListener('click', function() {
						_this.showLevelPanel = false
					}, false)
				}
			}
		},
		filters: {
			formatRole: (value) => { //当前选中访客角色格式化
				switch (value) {
					case 'agent':
						return '客服'
						break
					case 'client':
						return '访客'
						break
				}
			},
			/**
			 * 【聊天纪录时间】
			 * */
			formatTime: (value) => {
				const time_month = new Date(value).getMonth() + 1
				const time_date = new Date(value).getDate()
				const time_lef = time_month + '月' + time_date + '日'
				const time_rig = value.split(" ")[1].substring(0, 5)
				const time = time_lef + ' ' + time_rig
				return time
			},
		},
		updated() {
			let video = document.getElementsByClassName("videoId")
			if (video) {
				// 隐藏video标签控制条右侧三个点
				for (let i = 0; i < video.length; i++) {
					video[i]['disablePictureInPicture'] = true; //disablePictureInPicture的属性改为true
				}
			}
		},
		methods: {
			levelPanelToggle(event) {
				this.showLevelPanel = !this.showLevelPanel
			},
			editWorkorderPriority(ticketId, priority) {
				this.$http.editWorkorderPriorityAPI({
					ticketId: ticketId,
					priority: priority,
				}).then(res => {
					if (res.status == 1) {
						this.$message({
							showClose: true,
							message: res.msg,
							type: 'success',
							duration: 3 * 1000
						})
						this.hasOperate = true
						this.getWorkorderDetail(this.ticketId)
					} else {
						this.$message({
							showClose: true,
							message: res.msg,
							type: 'error',
							duration: 3 * 1000
						})
					}
					this.showLevelPanel = false
				})
			},
			getWorkorderVisitorInfo(visitorId) {
				this.$http.getWorkorderVisitorInfoAPI({
					visitorId: visitorId
				}).then(res => {
					if (res.status == 1) {
						this.visitorData = res.data
						console.log('visitor===', res)
					}
				})
			},
			/**
			 * 点击宝贝链接
			 */
			goodsLinkerHandler(url) {
				// shell.openExternal(url)
				window.open(url)
			},
			/**
			 * 【小程序访客发送商品】
			 */
			goodsWxappHandler() {
				this.$message({
					showClose: true,
					message: '该链接属于小程序内部链接，只能在微信内部打开',
					type: 'warning',
					duration: 3 * 1000
				})
			},
			/**
			 * Author: brand
			 * Creation Time: 2019-02-19 11:40
			 * Description: 移除className
			 */
			removeClass(el, className) {
				if (!this.hasClass(el, className)) {
					return
				}
				let newClass = el.className.split(' ')
				newClass.forEach(function(val, index, newClass) {
					if (val === className) {
						newClass.splice(index, 1);
					}
				})
				el.className = newClass.join(' ')
			},
			/**
			 * Author: brand
			 * Creation Time: 2019-02-19 11:40
			 * Description: 添加className
			 */
			addClass(el, className) {
				if (this.hasClass(el, className)) {
					return
				}
				let newClass = el.className.split(' ')
				newClass.push(className)
				el.className = newClass.join(' ')
			},
			/**
			 * Author: brand
			 * Creation Time: 2019-02-19 11:40
			 * Description: 判断是否有className
			 */
			hasClass(element, cls) {
				return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
			},
			/**
			 * Author: brand
			 * Creation Time: 2019-02-19 11:28
			 * Description: 播放音频
			 */
			voicePlay(event) {
				let symbolVoice = event.currentTarget.getElementsByClassName('wifi-symbol')[0]
				let audioId = event.currentTarget.getElementsByClassName('audioId')[0]
				let currentAudioIndex = event.currentTarget.getElementsByClassName('audioId')[0].getAttribute('index')
				let parentBox = event.currentTarget.parentElement
				if (this.hasClass(parentBox, 'voicing')) {
					this.removeClass(parentBox, 'voicing')
					audioId.pause() // 暂停-从头播放
					audioId.currentTime = 0
					this.removeClass(symbolVoice, 'bofang')
				} else {
					document.querySelectorAll('.bubble').forEach((item, i) => {
						this.removeClass(item, 'voicing')
					})
					document.querySelectorAll('.wifi-symbol').forEach((item, i) => {
						this.removeClass(item, 'bofang')
					})
					document.querySelectorAll('audio').forEach((audioItem, audioIndex) => {
						audioItem.pause()
						audioItem.currentTime = 0
					})

					this.addClass(parentBox, 'voicing')
					if (this.hasClass(symbolVoice, 'bofang')) {
						audioId.pause() // 暂停-从头播放
						audioId.currentTime = 0
						this.removeClass(symbolVoice, 'bofang')
					} else {
						audioId.play()
						this.addClass(symbolVoice, 'bofang')
					}
				}
				// 播放完后执行
				audioId.addEventListener('ended', () => {
					this.removeClass(symbolVoice, 'bofang')
				}, false);
			},
			/**
			 * Author: brand
			 * Creation Time: 2019-02-25 14:55
			 * Description: 播放视频
			 */
			videoPlay(event) {
				let _event = event
				let videoId = _event.currentTarget.parentElement.parentElement.getElementsByClassName('videoId')[0]
				let parentBox = _event.currentTarget.parentElement.parentElement.parentElement
				// videoId.play()
				if (this.hasClass(parentBox, 'playing')) {
					this.removeClass(parentBox, 'playing')
					videoId.pause() // 暂停-从头播放
					videoId.currentTime = 0
					_event.currentTarget.parentElement.style.display = 'block'
				} else {
					document.querySelectorAll('.video_mask').forEach((item, i) => {
						item.style.display = 'block'
					})
					document.querySelectorAll('.bubble').forEach((item, i) => {
						this.removeClass(item, 'playing')
					})
					document.querySelectorAll('video').forEach((videoItem, videoIndex) => {
						videoItem.pause()
						_event.currentTarget.parentElement.style.display = 'block'
						videoItem.currentTime = 0
					})
					this.addClass(parentBox, 'playing')
					_event.currentTarget.parentElement.style.display = 'none'
					videoId.play()
				}
				// 播放完后执行
				videoId.addEventListener('ended', () => {
					this.removeClass(parentBox, 'playing')
					videoId.currentTime = 0
					document.querySelectorAll('.video_mask').forEach((item, i) => {
						item.style.display = 'block'
					})
				}, false);

			},
			// 暂停播放
			videoStop(event) {
				let _event = event
				let videoId = _event.currentTarget.parentElement.parentElement.getElementsByClassName('videoId')[0]
				let parentBox = _event.currentTarget.parentElement.parentElement
				this.removeClass(parentBox, 'playing')
				// videoId.pause()
				document.querySelectorAll('.video_mask').forEach((item, i) => {
					item.style.display = 'block'
				})
				videoId.currentTime = 0
			},
			formatTrendEmoji(val) {
				let s_name = val;
				let s_img = [];
				let rules = /:([^:][a-z_\-]+):/g
				s_name.replace(rules, function($1, $2) {
					s_img.push($2);
				})
				for (let i = 0; i < s_img.length; i++) {
					let str = ''
					let r_str = ':' + s_img[i] + ':'
					for (let key in emojiData) {
						if (s_img[i] == key) {
							let imgPath = require(`@/libs/emoji/images/${s_img[i]}.gif`)
							str = s_name.replace(r_str, `<img style="display: inline-block;max-width: 24px;max-height: 24px;" src="` +
								imgPath + `" class="img">`)
						} else {
							str = s_name.replace(r_str, r_str)
						}
						s_name = str
					}
				}
				return s_name
			},
			viewChatHistory() {
				this.dialogChatHistoryVisible = true
				if (this.historyList.length === 0) {
					this.handlerLoadHistory()
				}

			},
			handleChatHistoryClose() {
				this.dialogChatHistoryVisible = false
			},
			handlerLoadHistory() {
				let loadHisParams = {
					pageNum: this.pageNum++,
					visitorId: this.workorderData.visitorId,
					messageId: this.workorderData.callingId
				}
				this.$http.getChatHistory(loadHisParams).then(res => {
					if (res.status == 1) {
						this.historyList = res.data.concat(this.historyList)
						this.historyStatus = res.historyStatus
						console.log('res=', res)
					}
				})


			},
			rulesChange() {
				let selectId = this.setRules
				let selectedIsRule = this.$refs.categoryCascader.getCheckedNodes()[0].data.isRule
				let postData = {}
				if (selectedIsRule == 1) {
					this.$confirm('是否触发自动处理规则?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						postData = {
							ticketId: this.ticketId,
							categoryId: selectId,
							isTriggerRule: 1, // 是否触发规则,1为是,0为不是
						}
						this.$http.editTicketCategoryAPI(postData).then(res => {

							if (res.status == 1) {
								this.$message({
									showClose: true,
									message: res.msg,
									type: 'success',
									duration: 3 * 1000
								})
								this.hasOperate = true
								this.getWorkorderDetail(this.ticketId)
							} else {
								this.$message({
									showClose: true,
									message: res.msg,
									type: 'error',
									duration: 3 * 1000
								})
							}
						})
					}).catch(() => {
						postData = {
							ticketId: this.ticketId,
							categoryId: selectId,
							isTriggerRule: 0, // 是否触发规则,1为是,0为不是
						}
						this.$http.editTicketCategoryAPI(postData).then(res => {

							if (res.status == 1) {
								this.$message({
									showClose: true,
									message: res.msg,
									type: 'success',
									duration: 3 * 1000
								})
								this.hasOperate = true
								this.getWorkorderDetail(this.ticketId)
							} else {
								this.$message({
									showClose: true,
									message: res.msg,
									type: 'error',
									duration: 3 * 1000
								})
							}
						})
					});
				} else {
					postData = {
						ticketId: this.ticketId,
						categoryId: selectId,
					}
					this.$http.editTicketCategoryAPI(postData).then(res => {

						if (res.status == 1) {
							this.$message({
								showClose: true,
								message: res.msg,
								type: 'success',
								duration: 3 * 1000
							})
							this.hasOperate = true
							this.getWorkorderDetail(this.ticketId)
						} else {
							this.$message({
								showClose: true,
								message: res.msg,
								type: 'error',
								duration: 3 * 1000
							})
						}
					})
				}

			},
			// 获取分类数据
			getSortData() {
				this.$http.getWorkorderSortAPI().then(res => {

					if (res.status == 1) {
						this.optionRules = this.recursionFunction(res.data.categoryList)
						console.log('res2=', res)
					}
				})
			},
			recursionFunction(array) {
				if (!Array.isArray(array)) {
					array = []
				}
				let categoryList = []
				array.map(item => {

					let categoryItem = {}
					if (item.isFolder == 0 || item.subTicketCategory.length > 0) {
						categoryItem.label = item.categoryName
						categoryItem.value = item.id
						categoryItem.isRule = item.isRule
						if (item.subTicketCategory.length > 0) {
							categoryItem.children = this.recursionFunction(item.subTicketCategory)
						}
						categoryList.push(categoryItem)
					}
				})
				return categoryList
			},
			csChange(val) {
				let csId = val[0]
				if (csId) {
					this.$http.redeployWorkorderAPI({
						ticketId: this.ticketId,
						assigneeId: csId,
					}).then(res => {

						if (res.status == 1) {
							this.hasOperate = true
							this.getWorkorderDetail(this.ticketId)
						}
					})
					console.log(csId)
				}

			},
			// 获取所有人工客服
			getAllService() {
				this.$http.getAllServiceAPI().then(res => {

					if (res.status == 1) {
						if (res.data.csList.length > 0) {
							let serviceList = []
							res.data.csList.map(item => {
								let csItem = {}
								csItem.label = item.csName
								csItem.value = item.csId
								serviceList.push(csItem)
							})
							this.options = serviceList
						}

					}
					console.log(res)
				})
			},
			showEmojiFn() {
				this.showEmoji = !this.showEmoji
			},
			chooseImage() {
				this.$refs.imageFile.click()
			},
			sendImage(e) {
				let img = e.target.files[0]
				let type = img.type
				let size = img.size
				let formdata = new FormData()
				formdata.set('file', img)
				this.$http.chatSendImages(formdata).then(res => {

					if (res.status == 1) {
						this.replyParams.content = res.data
						this.replyParams.contentType = 'image'
						this.$nextTick(() => {
							this.sendMsgReply()
						})
					}
				})
				console.log(e)
			},
			//选择表情
			selectEmoji(emoji) {
				const newEmoji = "[" + emoji.value[0] + "]"
				this.showEmoji = false
				this.sendBtn = false
				this.textarea += newEmoji //":" + emoji.name + ":";
			},
			// 获取工单详情
			getWorkorderDetail(id) {
				this.$http.getWorkorderDetailAPI({
					ticketId: id
				}).then(res => {
					console.log('WorkorderDetail==',res)
					if (res.status == 1) {
						this.workorderData = res.data.ticketData
						this.detailList = res.data.detailList
						this.replyList = []
						this.detailList.map((item,index) => {
							if(item.actionType==1){
								this.replyList.push(item)
							}
						})
						eventBus.$emit('changeWorkorderStatus', {
							ticketId: this.ticketId,
							status: this.workorderData.status,
							priority: this.workorderData.priority
						})
						if (res.data.ticketData.visitorId) {
							this.getWorkorderVisitorInfo(res.data.ticketData.visitorId)
						}
						let csIdArr = res.data.ticketData.assignedCsId
						this.defaultOption = csIdArr
						this.setRules = res.data.ticketData.categoryId
						if (this.isSendMsg) {
							this.isSendMsg = false
							this.scrollBottom()
						}
					}
				}).catch(() => {
					this.isSendMsg = false
				})
			},
			// 渲染状态
			renderProcessState(status) {
				switch (status) {
					case '1':
					case 1:
						return {
							className: 'dfp',
							txt: '待分配',
						}
					case '2':
					case 2:
						return {
							className: 'dhf',
							txt: '待回复',
						}
					case '3':
					case 3:
						return {
							className: 'clz',
							txt: '处理中',
						}
					case '4':
					case 4:
						return {
							className: 'yjj',
							txt: '已解决',
						}
					case '5':
					case 5:
						return {
							className: 'bxcl',
							txt: '不需处理',
						}
				}
			},
			// 渲染优先级
			renderLevel(level) {
				switch (level) {
					case '0':
					case 0:
						return {
							className: 'level-low',
							txt: '低',
						}
					case '1':
					case 1:
						return {
							className: 'level-middle',
							txt: '中',
						}
					case '2':
					case 2:
						return {
							className: 'level-high',
							txt: '高 ',
						}
					case '3':
					case 3:
						return {
							className: 'level-warn',
							txt: '紧急',
						}
				}
			},
			// 渲染头像
			renderAvatar(avatar) {
				if (avatar) {
					const img = avatar.indexOf('https://')
					const img2 = avatar.indexOf('http://')
					if (img + img2 + 1 < 0) {
						return 'https://mp.weiliaokefu.com' + avatar
					} else {
						return avatar
					}
				}
			},
			//  不需处理
			withoutHandle() {
				this.$http.closeWorkorderAPI({
					ticketId: this.ticketId
				}).then(res => {

					if (res.status == 1) {
						this.$message({
							showClose: true,
							message: '操作成功',
							type: 'success',
							duration: 3 * 1000
						})
						this.hasOperate = true
						this.getWorkorderDetail(this.ticketId)
					} else {
						this.$message({
							showClose: true,
							message: '操作失败',
							type: 'error',
							duration: 3 * 1000
						})
					}
				})
			},
			// 已解决
			solveHandle() {
				this.$http.solveWorkorderAPI({
					ticketId: this.ticketId
				}).then(res => {

					if (res.status == 1) {
						this.$message({
							showClose: true,
							message: '操作成功',
							type: 'success',
							duration: 3 * 1000
						})
						this.hasOperate = true
						this.getWorkorderDetail(this.ticketId)
					} else {
						this.$message({
							showClose: true,
							message: '操作失败',
							type: 'error',
							duration: 3 * 1000
						})
					}
				})
			},
			// 重新打开
			reloadWorkorder() {
				this.$http.reopenWorkorderAPI({
					ticketId: this.ticketId
				}).then(res => {

					if (res.status == 1) {
						this.$message({
							showClose: true,
							message: '操作成功',
							type: 'success',
							duration: 3 * 1000
						})
						this.hasOperate = true
						this.getWorkorderDetail(this.ticketId)
					} else {
						this.$message({
							showClose: true,
							message: '操作失败',
							type: 'error',
							duration: 3 * 1000
						})
					}
				})
			},
			renderActionIcon(type) {
				switch (type) {
					case '2':
					case 2:
						return 'workorderTransfer' // 转派
					case '3':
					case 3:
						return 'workorderFinished' //  已解决
					case '4':
					case 4:
						return 'workorderCancel' // 不需处理
					case '5':
					case 5:
						return 'workorderReload' // 重新打开
					case '6':
					case 6:
						return '' // 抄送
					case '7':
					case 7:
						return 'priority' //  修改优先级
					case '8':
					case 8:
						return 'editworkorder' // 修改分类
				}
			},
			sendMsgReply() {
				this.$http.replyWorkorderAPI(this.replyParams).then(res => {

					if (res.status == 1) {
						this.replyParams.content = ''
						this.textarea = ''
						this.$refs.imageFile.value = ''
						this.isSendMsg = true
						this.hasOperate = true
						this.getWorkorderDetail(this.ticketId)
					}
				})
			},
			formatTrendEmoji(val) {
				let s_name = val;
				let s_img = [];
				let rules = /:([^:][a-z_\-]+):/g
				s_name.replace(rules, function($1, $2) {
					s_img.push($2);
				})
				for (let i = 0; i < s_img.length; i++) {
					let str = ''
					let r_str = ':' + s_img[i] + ':'
					for (let key in emojiData) {
						if (s_img[i] == key) {
							let imgPath = require(`@/libs/emoji/images/${s_img[i]}.gif`)
							str = s_name.replace(r_str, `<img src="` + imgPath + `" class="img">`)
						} else {
							str = s_name.replace(r_str, r_str)
						}
						s_name = str
					}
				}
				return s_name
			},
			//Ctrl+Enter 换行
			textareaKeyDown(e) {
				this.isKeyInput = true
				if (e.keyCode == 13 && e.ctrlKey) {
					this.textarea += "\n"
				} else if (e.keyCode == 13) {
					e.preventDefault()
					if (this.textarea) {
						this.replyWorkorder()
					} else {
						this.$message({
							showClose: true,
							message: '请输入内容',
							type: 'error',
							duration: 3 * 1000
						})
					}
				}
			},
			scrollBottom() {
				setTimeout(() => {
					this.$refs.chatRecordWrap.scrollTop = this.$refs.chatRecordWrap.scrollHeight;
				}, 10)
			},
			// 回复
			replyWorkorder() {
				let partten = /\[(.+?)\]/g
				if (this.textarea.match(partten)) {
					this.textarea.match(partten).map(item => {
						for (let key in emojiData) {
							let emojiCN = '[' + emojiData[key][0] + ']'
							let emojiEN = ':' + key + ':'
							let reg = new RegExp("\\[(" + emojiData[key][0] + ")\\]", "ig")
							if (item == emojiCN) {
								this.textarea = this.textarea.replace(new RegExp(reg, "g"), emojiEN)
							}
						}
					})
				}
				this.replyParams.content = this.textarea
				this.replyParams.contentType = 'text'
				if (this.replyParams.content.trim().length == 0) {
					this.$message({
						showClose: true,
						message: '回复内容不能为空',
						type: 'error',
						duration: 3 * 1000
					})
					return false
				} else if (this.replyParams.content.trim().length > 5000) {
          this.$message.error('发送内容过长，请清除内容格式或精简内容！')
          return false
        }
				this.$nextTick(() => {
					this.sendMsgReply()
				})
			}
		},
	}
</script>

<style lang="scss">
	// @import '~@/assets/css/common/index';
	//播放按钮
	// video::-webkit-media-controls-play-button {
	//   display: none;
	// }
	//进度条
	video::-webkit-media-controls-timeline {
		display: none;
	}

	//观看的当前时间
	video::-webkit-media-controls-current-time-display {
		display: none;
	}

	//剩余时间
	video::-webkit-media-controls-time-remaining-display {
		display: none;
	}

	//音量按钮
	video::-webkit-media-controls-mute-button {
		display: none;
	}

	video::-webkit-media-controls-toggle-closed-captions-button {
		display: none;
	}

	//音量的控制条
	video::-webkit-media-controls-volume-slider {
		display: none;
	}

	.WorkOrderDetail {
		display: flex;
		height: 100%;
		border-left: 1px solid #eee;
		box-sizing: border-box;
		background-color: #f2f3f5;
		$mainPadding: 15px;
		line-height: 1!important;
		.WorkOrderDetail-container {
			background-color: #f2f3f5!important;
			flex: 1;
			display: flex;
			flex-direction: column;
			position: relative;
			padding-bottom: 180px!important;
			.workorder-detail-header {
				display: flex;
				align-items: center;
				border-bottom: 1px solid #eee;
				box-sizing: border-box;
				padding: $mainPadding;
				box-sizing: border-box;
				margin-bottom: 15px;
				background: #fff;
				.workorder-info {
					flex: 1;

					.workorder-info-head {
						display: flex;
						align-items: center;
						font-size: 14px!important;
						box-sizing: border-box;
						padding: 0!important;
						&>div {
							white-space: nowrap;
						}

						.level {
							display: inline-block;
							color: #fff;
							text-align: center;
							border-radius: 4px;
							margin-right: 6px;
							cursor: pointer;
							position: relative;
							padding: 3px 8px;
							width: auto!important;
							.levelPanel {
								position: absolute;
								top: 8px;
								left: 15px;
								z-index: 999;
								padding: 5px 0;
								background-color: #fff;
								border-radius: 4px;
								min-width: 130px;
								text-align: left;
								line-height: 30px;
								box-shadow: 0 5px 30px 0 rgba(52, 63, 75, .2);
								color: #333;

								.levelItem {
									padding: 0 15px;
									font-size: 13px;

									&:hover {
										background-color: #4ca0ff;
										color: #fff;
									}
								}
							}

							&.level-warn {
								background-color: red;
							}

							&.level-high {
								background-color: #fb894f;
							}

							&.level-middle {
								background-color: #4ca0ff;
							}

							&.level-low {
								background-color: gray;
							}
						}

						.workorder-status {
							margin:0 8px;
							padding-left: 8px;
							box-sizing: border-box;
							border-left: 2px solid #eee;
							height: 24px;
							line-height: 24px;
							&.dfp {
								color: orange;
							}

							&.dhf {
								color: red;
							}

							&.clz {
								color: #3296fa;
							}

							&.yjj {
								color: #00ce7d;
							}

							&.bxcl {
								color: #666666;
							}
						}
					}

					.workorder-function {
						display: flex;
						align-items: center;
						height: 24px;

						.function-item {
							display: flex;
							align-items: center;
							border-left: 2px solid #eee;
							margin-left: 6px;
							padding-left: 6px;
							box-sizing: border-box;
							.el-cascader {
								height: 24px!important;
								line-height: 24px!important;

								.el-input__suffix {
									top: -8px;
									height: auto;
								}
							}

							.el-input__inner {
								padding: 0 10px;
								font-size: 14px!important;
								padding-right: 30px;
								width: 120px!important;
								border: none;
								height: 24px!important;
								box-sizing: border-box;
							}
						}
					}

				}

				.workorder-operation {
					display: flex;
					align-items: center;
					width: 150px;
					color: #3296fa;

					.workorder-operation-item {
						cursor: pointer;
						text-align: center;
						margin: 0 5px;
					}
				}
			}

			.workorder-detail-main {
				height: 240px!important;
				flex: initial!important;
				padding: 0 $mainPadding $mainPadding;
				box-sizing: border-box;
				overflow-y: auto;
				background: #fff;
				margin-bottom: 15px;
				&:hover{
					&::-webkit-scrollbar{
						display: block;
						width: 4px;
					}
					&::-webkit-scrollbar-thumb{
						background-color: #ddd;
					}
				}
				.workorder-record-container {
					margin-top: 20px;

					.reply-conent {
						margin: 5px 0;
						padding: 8px 12px;
						box-sizing: border-box;
						background-color: #fffadd;

						img {
							max-width: 300px !important;
						}
					}

					.workorder-record-head {
						display: flex;
						align-items: center;

						.workorder-record-head-icon {
							width: 18px;
							height: 18px;
							border-radius: 50%;
							overflow: hidden;
							margin-right: 8px;

							img {
								display: inline-block;
								width: 100%;
								height: 100%;
								border-radius: 50%;
								overflow: hidden;
							}

							.workorderAdd {
								color: rgb(111, 208, 72);
							}

							.workorderCancel {
								color: rgb(184, 188, 196);
							}

							.workorderFinished {
								color: rgb(47, 204, 128);
							}

							.workorderReload {
								color: rgb(111, 208, 72);
							}

							.workorderTransfer {
								color: rgb(251, 137, 79);
							}

							.editworkorder {
								color: rgb(100, 213, 251);
							}

							.priority {
								color: #f4c81c;
							}
						}

						.from-user,
						.to-user {
							color: #333;
							margin-right: 10px;
						}

						.workorder-record-tips {
							color: #999;
							margin-right: 10px;
						}

						.workorder-record-time {
							color: #999;
						}
					}

					.workorder-content {
						padding: 10px 20px;
						box-sizing: border-box;

						a {
							color: #3296fa;
							cursor: pointer;
						}

						h1 {
							font-size: 2em;
						}

						h2 {
							font-size: 1.5em;
						}

						h3 {
							font-size: 1.17em;
						}

						h4 {
							font-size: 1em;
						}

						h5 {
							font-size: 0.83em;
						}

						img {
							max-width: 300px !important;
						}
					}
				}
			}
			.workorder-detail-chatRecordWrap{
				height: initial!important;
				flex: 1!important;
				.no-data{
					color: #999;
					padding-top: 30px;
				}
			}
			.workorder-detail-footer {
				height: 180px;
				width: 100%;
				border-top: 1px solid #eee;
				padding: 0 $mainPadding;
				box-sizing: border-box;
				display: flex;
				flex-direction: column;
				position: absolute!important;
				bottom: 15px;
				left: 0;
				background: #fff!important;
				padding: 15px!important;
				.chat-tool-bar {
					height: 30px;
					line-height: 30px;
				}

				.chat-input-container {

					/*flex: 1;*/
					.chat-input {
						width: 100%;
						height: 90px;
						padding: 6px;
						box-sizing: border-box;
						border: none;
						resize: none;
						outline: none;
					}
				}

				.send-msg-btn {
					/*height: 30px;*/
					font-size: 0;

					span {
						float: right;
						cursor: pointer;
						font-size: 12px;
						background-color: #3296fa;
						color: #fff;
						padding: 8px 18px;
						box-sizing: border-box;
					}
				}
			}

		}

		.workorder-from-user-container {
			width: 200px;
			position: relative;
		}

		.dialogChatHistory {
			z-index: 9999!important;
			.el-dialog__header {
				border-bottom: 1px solid #eee;
			}

			.loadHistory {
				text-align: center;
				background-color: rgba(155, 155, 155, 0.16);
				line-height: 40px;

				span {
					cursor: pointer;
					font-size: 12px;
					color: #333;
				}
			}

			.messages {
				width: calc(100% - 40px);
				height: 400px;
				padding: 10px 20px;
				overflow-y: scroll;

				.has-new-msg {
					position: absolute;
					bottom: 5px;
					right: 0;
					background-color: #fff;
					cursor: pointer;
					padding: 8px 10px;
					border-top-left-radius: 10px;
					border-bottom-left-radius: 10px;
					box-sizing: border-box;
					color: #3296fa;

					.svg-icon {
						margin-right: 3px;
					}
				}

				&.isHeight {
					height: calc(100% - 60px);
				}

				.client-event {
					text-align: center;
					color: #808080;
					margin: 10px;

					.msg-date {
						margin-bottom: 5px;
						color: #808080;
						text-align: center;
					}
				}

				.msg-agent,
				.msg-client {
					position: relative;

					.j-user {
						display: table-cell;
						width: 36px;
						height: 36px;

						.agent-name {
							display: inline-block;
							width: 36px;
							height: 36px;
							line-height: 36px;
							font-size: 14px;
							color: #fff;
							text-align: center;
							border-radius: 100%;
							overflow: hidden;

							img {
								display: block;
								width: 100%;
								height: 100%;
							}
						}
					}

					.time-sender {
						line-height: 26px;
						font-size: 12px;
						color: #808080;
						clear: both;
					}

					.bubble {
						position: relative;
						width: 100%;

						&:hover {
							.more_action {
								display: inline-block;
							}
						}

						.more_action {
							display: none;
							float: left;
							background-color: #fff;
							padding: 0;
							font-size: 14px;
							box-sizing: border-box;
							color: #000;
							font-weight: bold;
							cursor: pointer;
							line-height: 14px;
							border-radius: 1px;

							&:hover {
								background-color: #eee;
							}
						}

						img {
							max-width: 80%;
						}

						.text {
							border-radius: 2px;
							padding: 5px 10px;
							font-size: 14px;
							line-height: 26px;
							word-wrap: break-word;
							word-break: break-all;
							color: #666;

							.img {
								width: 24px;
							}

							.text-emoji {
								margin: 0 2px;
								width: 24px;
								height: auto;
								display: inline-block;
								vertical-align: -5px;
							}

							a {
								color: $mainColor;
							}
						}

						.el-dialog {
							.el-dialog__body {
								padding: 20px;

								img {
									width: 100%;
								}
							}
						}

						.upload-img {
							max-width: 250px;
							height: auto;
						}

						.upload-img-failed {
							width: 70px;
						}

						.upload-img-failed-txt {
							padding-top: 3px;
							font-size: 12px;
							color: #999;
							text-align: center;
						}

						.upload-file {
							color: #A2A9B2;
							padding: 10px;

							.fa {
								font-size: 26px !important;
							}

							.file-name {
								padding: 0 5px;
							}

							.file-download {
								color: $mainColor;
							}
						}

						.foresee {
							.text {
								display: inline-block;
							}

							p {
								display: inline-block;
								font-size: 12px;
								color: #9b9b9b;
							}
						}
					}
				}

				.msg-agent {
					padding: 20px 50px 20px 30%;

					.content_container {
						position: relative;
						display: inline-block;
						float: right;
						padding-left: 25px;

						.more_action {
							position: absolute;
							bottom: 0;
							left: 0;
						}

						.more_action_item_box {
							position: absolute;
							display: none;
							left: -55px;
							bottom: 0;
							background-color: #fff;
							border: 1px solid #eee;
							border-radius: 4px;
							padding: 5px 0;
							box-sizing: border-box;
							font-size: 13px;
							color: #555555;

							.more_action_item {
								padding: 10px;
								box-sizing: border-box;
								cursor: pointer;

								&:hover {
									background-color: #eee;
								}
							}
						}
					}

					.j-user {
						float: right;
						margin: 0 -50px 0 10px;

						.agent-name {
							background: #3296fa;

							img {
								background: #fff;
							}
						}
					}

					.time-sender {
						text-align: right;
					}

					.bubble {
						float: right;

						.text {
							color: #010101;
							background-color: #cce6ff;
							border: 1px solid #bed6ee;
							float: right;
						}

						// &:after{
						//     position: absolute;
						//     top: 15px;
						//     right: -6px;
						//     content: "";
						//     width: 0;
						//     height: 0;
						//     border-top: 5px solid transparent;
						//     border-bottom: 5px solid transparent;
						//     border-left: 6px solid #ebebeb;
						// }
					}
				}

				.msg-client {
					padding: 20px 30% 20px 50px;

					.content_container {
						position: relative;
						display: inline-block;
						padding-right: 25px;

						.more_action {
							position: absolute;
							bottom: 0;
							right: 0;
						}

						.more_action_item_box {
							position: absolute;
							display: none;
							right: -55px;
							bottom: 0;
							background-color: #fff;
							border: 1px solid #eee;
							border-radius: 4px;
							padding: 5px 0;
							box-sizing: border-box;
							font-size: 13px;
							color: #555555;

							.more_action_item {
								padding: 10px;
								box-sizing: border-box;
								cursor: pointer;

								&:hover {
									background-color: #eee;
								}
							}
						}
					}

					.j-user {
						float: left;
						margin-right: 10px;
						margin: 0 10px 0 -50px;

						.agent-name {
							background: #ff7376;
						}
					}

					.time-sender {
						text-align: left;
					}

					.bubble {
						float: left;

						.text {
							color: #010101;
							background-color: #fff;
							border: 1px solid #ededee;
							float: left;
						}

						// &:before{
						//     position: absolute;
						//     top: 15px;
						//     left: -6px;
						//     content: "";
						//     width: 0;
						//     height: 0;
						//     border-top: 5px solid transparent;
						//     border-bottom: 5px solid transparent;
						//     border-right: 6px solid #dcedfa;
						// }
					}

					&.msg-client-inputing {
						.bubble {
							background: #fff;
							border: 1px solid #eee;

							.text,
							.inputing-img,
							.inputing-text {
								display: inline-block;
								vertical-align: middle;
							}

							.inputing-img {
								margin: 0 5px;
								width: 44px;
								height: 4px;
								background: url(../../../assets/images/mp_chat_inputing.gif) center no-repeat;
							}

							.inputing-text {
								color: #b8bcc4;
							}
						}
					}
				}

				.goodsLink {
					padding: 10px;
					font-size: 14px;
					line-height: 26px;
					background: #fff;
					border-radius: 2px;
					border: 1px solid #e4e4e4;
					word-wrap: break-word;
					word-break: break-all;

					&:hover {
						cursor: pointer;
					}

					.goodsMain {
						width: 110px;
						height: 80px;
						padding-left: 90px;

						.goodsLef {
							float: left;
							width: 80px;
							height: 80px;
							margin-left: -90px;

							.wxapp-img {
								width: 100%;
								height: 100%;
								border: 1px solid #ececec;
								box-sizing: border-box;
							}

							span {
								display: block;
								width: 100%;
								height: 100%;
								border: 1px solid #ececec;
								box-sizing: border-box;

								img {
									display: block;
									width: 100%;
									height: 100%;
									max-width: 100%;
								}
							}
						}

						.goodsRig {
							width: 100%;
							height: 80px;

							h3 {
								font-size: 12px;
								line-height: 16px;
								max-height: 32px;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 2;
								/* autoprefixer: ignore next */
								-webkit-box-orient: vertical;
							}

							p {
								margin-top: 16px;
								font-size: 14px;
								line-height: 28px;
								color: #ff2f2f;

								em {
									font-family: Arial;
									font-style: normal;
								}
							}
						}
					}
				}

				.couponMsg {
					padding: 10px;
					font-size: 14px;
					line-height: 26px;
					background: #fff;
					border-radius: 2px;
					border: 1px solid #e4e4e4;
					word-wrap: break-word;
					word-break: break-all;

					&:hover {
						cursor: pointer;
					}

					.couponMain {
						white-space: nowrap;
						font-size: 0;

						.couponLef {
							width: 80px;
							display: inline-block;
							vertical-align: top;
							margin-right: 10px;

							img {
								width: 100%;
								max-width: 100%;
							}
						}

						.couponRig {
							display: inline-block;
							min-width: 80px;

							h3 {
								font-size: 12px;
								color: #333;
								font-weight: bold;
							}

							.time {
								font-size: 12px;
								color: #999;
								line-height: 20px;
							}

							.price {
								font-size: 12px;
								color: #F93B2D;
							}
						}
					}
				}

				.expressLink {
					padding: 4px 10px 12px;
					font-size: 14px;
					line-height: 26px;
					background: #fff;
					border-radius: 2px;
					border: 1px solid #e4e4e4;
					word-wrap: break-word;
					word-break: break-all;

					&:hover {
						cursor: pointer;
					}

					.expressMain {
						white-space: nowrap;
						font-size: 0;

						.express-top {
							font-size: 12px;
						}

						.expressLef {
							width: 70px;
							height: 70px;
							display: inline-block;
							vertical-align: top;
							margin-right: 10px;
							border-radius: 5px;
							overflow: hidden;
							border: 1px solid #ddd;

							img {
								width: 100%;
								max-width: 100%;
							}
						}

						.expressRig {
							display: inline-block;
							min-width: 80px;
							width: 180px;

							h3 {
								font-size: 12px;
								text-overflow: ellipsis;
								white-space: nowrap;
								overflow: hidden;
								color: #333;
								margin-top: 5px;
								font-weight: bold;
							}

							.price {
								font-size: 12px;
								color: #F93B2D;
							}
						}
					}
				}

				.deliveryMsg,
				.arrivalMsg,
				.placeOrderMsg {
					width: 320px;
					border: 1px solid #eee;
					background-color: #fff;
					padding: 8px 14px;
					-webkit-box-sizing: border-box;
					-moz-box-sizing: border-box;
					box-sizing: border-box;

					.orderTitle {
						font-size: 13px;
						font-weight: bold;
						color: #333;
					}

					.orderGood-container {
						display: flex;
						margin: 8px 0;
						background-color: #fafafa;
						border-radius: 3px;
						overflow: hidden;
						cursor: pointer;

						.goods-image {
							width: 40px;
							height: 40px;

							img {
								width: 100%;
								height: 100%;
								max-width: 100% !important;
							}
						}

						.goods-detail {
							flex: 1;
							overflow: hidden;
							padding: 0 6px;
							box-sizing: border-box;

							.goods-order-title {
								font-size: 13px;
								color: #333;
								width: 100%;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
								line-height: 25px;
							}

							.goods-order-detail {
								font-size: 10px;
								color: #666;
							}
						}
					}

					.operation-btn {
						text-align: right;
						padding-top: 8px;

						a {
							background-color: #3396fb;
							color: #fff !important;
							font-size: 13px;
							padding: 6px 10px;
							border-radius: 6px;
							cursor: pointer;
							display: inline-block;
						}
					}
				}

				.deliveryMsg {
					.van-icon-arrow-down {
						cursor: pointer;
					}

					.deliveryInfo {
						font-size: 12px;
						line-height: 22px;

						.deliveryInfo-item {
							display: flex;

							.deliveryInfo-label {
								width: 60px;
							}

							.deliveryInfo-detail {
								flex: 1;
							}
						}
					}
				}

				.placeOrderMsg {
					.addressInfo {
						display: flex;
						font-size: 12px;

						.label {
							width: 40px;
						}

						.detail {
							flex: 1;
						}
					}
				}
			}
		}
	}
</style>
